import { IInvitationRepository } from '../ports/outbound/IInvitationRepository';
import { InvitationLocationItem } from '../domain/entities/InvitationLocationItem';

export class FetchInvitationLocationsUseCase {
  constructor(private readonly invitationRepository: IInvitationRepository) {}

  async execute(): Promise<InvitationLocationItem[]> {
    return this.invitationRepository.getLocations();
  }
}
